import React, { useEffect, useState } from 'react';
interface CountdownTimerProps {
  compact?: boolean;
}
export function CountdownTimer({
  compact = false
}: CountdownTimerProps) {
  const [timeLeft, setTimeLeft] = useState({
    hours: 2,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    const DURATION = 2 * 60 * 60 * 1000; // 2 hours in ms
    const STORAGE_KEY = 'clave_de_paz_timer_start';
    const initTimer = () => {
      let startTime = localStorage.getItem(STORAGE_KEY);
      if (!startTime) {
        startTime = Date.now().toString();
        localStorage.setItem(STORAGE_KEY, startTime);
      }
      return startTime;
    };
    let startTime = initTimer();
    const calculateTimeLeft = () => {
      const now = Date.now();
      const elapsed = now - parseInt(startTime!);
      const remaining = Math.max(0, DURATION - elapsed);
      if (remaining === 0) {
        // Reset timer
        localStorage.removeItem(STORAGE_KEY);
        startTime = Date.now().toString();
        localStorage.setItem(STORAGE_KEY, startTime);
        return {
          hours: 2,
          minutes: 0,
          seconds: 0
        };
      }
      return {
        hours: Math.floor(remaining / (1000 * 60 * 60) % 24),
        minutes: Math.floor(remaining / 1000 / 60 % 60),
        seconds: Math.floor(remaining / 1000 % 60)
      };
    };
    setTimeLeft(calculateTimeLeft());
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  if (compact) {
    return <div className="flex items-center gap-1 font-mono font-bold bg-black/20 px-2 py-1 rounded text-white" data-id="element-21">
        <span data-id="element-22">{formatNumber(timeLeft.hours)}</span>:
        <span data-id="element-23">{formatNumber(timeLeft.minutes)}</span>:
        <span data-id="element-24">{formatNumber(timeLeft.seconds)}</span>
      </div>;
  }
  return <div className="flex justify-center gap-3 my-6" data-id="element-25">
      <div className="flex flex-col items-center" data-id="element-26">
        <div className="bg-slate-900 text-white font-mono text-3xl md:text-4xl font-bold py-3 px-4 rounded-lg shadow-inner border border-slate-700 w-16 md:w-20 flex justify-center" data-id="element-27">
          {formatNumber(timeLeft.hours)}
        </div>
        <span className="text-xs text-slate-500 font-bold uppercase mt-2" data-id="element-28">
          Horas
        </span>
      </div>
      <div className="text-3xl md:text-4xl font-bold text-slate-400 mt-2" data-id="element-29">
        :
      </div>
      <div className="flex flex-col items-center" data-id="element-30">
        <div className="bg-slate-900 text-white font-mono text-3xl md:text-4xl font-bold py-3 px-4 rounded-lg shadow-inner border border-slate-700 w-16 md:w-20 flex justify-center" data-id="element-31">
          {formatNumber(timeLeft.minutes)}
        </div>
        <span className="text-xs text-slate-500 font-bold uppercase mt-2" data-id="element-32">
          Min
        </span>
      </div>
      <div className="text-3xl md:text-4xl font-bold text-slate-400 mt-2" data-id="element-33">
        :
      </div>
      <div className="flex flex-col items-center" data-id="element-34">
        <div className="bg-red-600 text-white font-mono text-3xl md:text-4xl font-bold py-3 px-4 rounded-lg shadow-inner border border-red-700 w-16 md:w-20 flex justify-center" data-id="element-35">
          {formatNumber(timeLeft.seconds)}
        </div>
        <span className="text-xs text-red-600 font-bold uppercase mt-2" data-id="element-36">
          Seg
        </span>
      </div>
    </div>;
}